import { Stack, Tooltip } from "@mui/material";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { TableStack } from "../../../../../pages/moments/analytics/send-table/table-stack";
import { ChannelIcon } from "../../../../channels/components/channel-icon";
import type { ChannelName } from "../../../../channels/types";
import type { PersonInUnsavedSegmentWithChannels } from "../../../server/supabase-segment-service";

export function useRecipientColumns({
  filterChannel,
}: {
  filterChannel?: ChannelName;
}): GridColDef<PersonInUnsavedSegmentWithChannels>[] {
  return useMemo(
    () => [
      {
        field: "first_name",
        headerName: "First Name",
        sortable: true,
        filterable: true,
        flex: 0.5,
        renderCell: (params: GridRenderCellParams<PersonInUnsavedSegmentWithChannels, string>) => (
          <TableStack>{params.value ?? "-"}</TableStack>
        ),
      },
      {
        field: "last_name",
        headerName: "Last Name",
        sortable: true,
        filterable: true,
        flex: 0.5,
        renderCell: (params: GridRenderCellParams<PersonInUnsavedSegmentWithChannels, string>) => (
          <TableStack>{params.value ?? "-"}</TableStack>
        ),
      },
      {
        field: "email",
        headerName: "Email",
        sortable: true,
        filterable: true,
        flex: 0.5,
        renderCell: (params: GridRenderCellParams<PersonInUnsavedSegmentWithChannels, string>) => (
          <TableStack>{params.value ?? "-"}</TableStack>
        ),
      },
      {
        field: "job_title",
        headerName: "Job Title",
        sortable: true,
        filterable: true,
        flex: 0.5,
        renderCell: (params: GridRenderCellParams<PersonInUnsavedSegmentWithChannels, string>) => (
          <TableStack>{params.value ?? "-"}</TableStack>
        ),
      },
      ...(filterChannel
        ? []
        : [
            {
              field: "channels",
              headerName: "Channels",
              sortable: false,
              filterable: false,
              flex: 0.5,
              renderCell: (
                params: GridRenderCellParams<
                  PersonInUnsavedSegmentWithChannels,
                  PersonInUnsavedSegmentWithChannels["channels"]
                >,
              ) =>
                params.value ? (
                  <Stack alignItems="center" height="100%" direction="row">
                    {channels.map((channel) =>
                      params.value?.[channel] ? (
                        <Tooltip key={channel} title={params.value?.[channel]?.display}>
                          <span>
                            <ChannelIcon channel={channel} fontSize="small" />
                          </span>
                        </Tooltip>
                      ) : null,
                    )}
                  </Stack>
                ) : null,
            },
          ]),
    ],
    [filterChannel],
  );
}

const channels = ["slack", "teams", "work_email", "personal_email", "twilio", "whatsapp"] as const;
